var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/product-badge-macros.j2"] = require( "macros/product-badge-macros.j2" );
dependencies["./web-exclusive-badge.j2"] = require( "./web-exclusive-badge.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-meta/badges.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "product/templates/product-meta/badges.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("quickshopUrl")) {
var t_4 = t_1.quickshopUrl;
} else {
cb(new Error("cannot import 'quickshopUrl'")); return;
}
context.setVariable("quickshopUrl", t_4);
if(t_1.hasOwnProperty("productUrl")) {
var t_5 = t_1.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_5);
if(t_1.hasOwnProperty("brandsUrl")) {
var t_6 = t_1.brandsUrl;
} else {
cb(new Error("cannot import 'brandsUrl'")); return;
}
context.setVariable("brandsUrl", t_6);
env.getTemplate("macros/product-badge-macros.j2", false, "product/templates/product-meta/badges.j2", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(t_7.hasOwnProperty("badgesMacro")) {
var t_10 = t_7.badgesMacro;
} else {
cb(new Error("cannot import 'badgesMacro'")); return;
}
context.setVariable("badgesMacro", t_10);
if(t_7.hasOwnProperty("pdpCallOutTextPrimary")) {
var t_11 = t_7.pdpCallOutTextPrimary;
} else {
cb(new Error("cannot import 'pdpCallOutTextPrimary'")); return;
}
context.setVariable("pdpCallOutTextPrimary", t_11);
if(t_7.hasOwnProperty("pdpCallOutTextSecondary")) {
var t_12 = t_7.pdpCallOutTextSecondary;
} else {
cb(new Error("cannot import 'pdpCallOutTextSecondary'")); return;
}
context.setVariable("pdpCallOutTextSecondary", t_12);
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productMeta")),"textualBadges") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productMeta")),"textualBadges")) && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"hideBadges")) {
output += "\n\n    ";
output += runtime.suppressValue((lineno = 5, colno = 16, runtime.callWrap(t_10, "badgesMacro", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productMeta")),"textualBadges")])), env.opts.autoescape);
output += "\n\n";
;
}
output += "\n\n";
env.getTemplate("./web-exclusive-badge.j2", false, "product/templates/product-meta/badges.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n";
output += runtime.suppressValue((lineno = 11, colno = 22, runtime.callWrap(t_11, "pdpCallOutTextPrimary", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")])), env.opts.autoescape);
output += "\n\n";
output += runtime.suppressValue((lineno = 13, colno = 24, runtime.callWrap(t_12, "pdpCallOutTextSecondary", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")])), env.opts.autoescape);
output += "\n\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-meta/badges.j2"] , dependencies)